import React, { useState, useCallback } from 'react';
import { observer } from 'mobx-react-lite';
import { useNavigate, useParams } from 'react-router-dom';
import styled from 'styled-components';
import { Field } from '../../../shared/ui/Field';
import { Button } from '../../../shared/ui/Button';
import { colors } from '../../../shared/styles/colors';
import {userStore} from '../../../entities/user/model/user-store';

const FormWrapper = styled.form`
  display: flex;
  flex-direction: column;
  gap: 36px;
  width: 100%;
  max-width: 400px;
`;

const ErrorMessage = styled.div`
  color: ${colors.errorState};
  font-size: 12px;
  margin-top: -8px;
  margin-bottom: 4px;
`;

export const ResetPasswordForm = observer(() => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { uidb64, token } = useParams<{ uidb64: string; token: string }>();

  // Use useCallback to prevent unnecessary re-renders
  const handlePasswordChange = useCallback((e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setPassword(e.target.value);
  }, []);

  const handleConfirmPasswordChange = useCallback((e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setConfirmPassword(e.target.value);
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    if (password !== confirmPassword) {
      setError('Пароли не совпадают');
      return;
    }

    if (password.length < 8) {
      setError('Пароль должен содержать минимум 8 символов');
      return;
    }

    try {
      if (!uidb64 || !token) {
        setError('Відсутній токен або UID для відновлення паролю');
        return;
      }

      const success = await userStore.resetPassword(token, password,confirmPassword, uidb64);
      if (success) {
        navigate('/login');
      }
    } catch (err) {
      setError('Произошла ошибка при смене пароля');
    }
  };

  const handleCancel = useCallback(() => {
    navigate('/');
  }, [navigate]);

  return (
    <FormWrapper onSubmit={handleSubmit}>
      <div className='flex flex-col gap-4'>
        <Field
          name="password"
          type="password"
          placeholder="Новий пароль *"
          value={password}
          onChange={handlePasswordChange}
        />
        <Field
          name="confirmPassword"
          type="password"
          placeholder="Підтвердіть пароль *"
          value={confirmPassword}
          onChange={handleConfirmPasswordChange}
        />
        {error && <ErrorMessage>{error}</ErrorMessage>}
      </div>
      <Button
        type="submit"
        variant="primary"
        fullWidth
        disabled={!password || !confirmPassword}
      >
        Змінити пароль
      </Button>

      <Button
        onClick={handleCancel}
        variant="text"
        color={colors.accentPrimary}
        fullWidth
      >
        Скасування
      </Button>
    </FormWrapper>
  );
});